"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Thumbnail_Wrapper_1 = __importDefault(require("./Thumbnail.Wrapper"));
function Skeleton(_a) {
    var _b = _a.aspectRatio, aspectRatio = _b === void 0 ? "1-1" : _b, _c = _a.width, width = _c === void 0 ? "100%" : _c;
    return (React.createElement(Thumbnail_Wrapper_1.default, { aspectRatio: aspectRatio, width: width },
        React.createElement("div", { className: "nimbus--thumbnail-skeleton" })));
}
exports.default = Skeleton;
//# sourceMappingURL=Thumbnail.Skeleton.js.map